import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { colors, gradients } from "../theme";
import bgImg from "../assets/bg-support-characters.svg";

const Container = styled.section`
  background: url(${bgImg}) bottom left no-repeat,
    ${gradients.redToPurple("150deg")};
  color: white;
  padding: 37px 33px 127px;
  width: 283px;

  h1 {
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 0.06rem;
    margin-bottom: 25px;
    text-transform: uppercase;

    strong {
      color: white;
      font-size: 4.2rem;
      font-weight: 600;
      display: block;
      letter-spacing: -0.06rem;
      line-height: 3.8rem;
      white-space: nowrap;
    }
  }

  p {
    line-height: 2.5rem;
  }

  nav {
    margin-top: 84px;
  }

  a {
    background: ${colors.purple};
    color: white !important;
    display: inline-block;
    font-size: 1.5rem;
    font-weight: 600;
    height: 44px;
    line-height: 44px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    transition: 0.3s;
    width: 100%;

    :hover {
      background: ${colors.primaryHover};
    }
  }
`;

function JoinUsAside() {
  return (
    <Container>
      <h1>
        Rejoignez <strong>les Socios</strong>
      </h1>
      <p>
        Afin de rester indépendant et en accès libre pour le plus grand nombre,
        et de continuer de vous proposer des enquêtes sur les magouilles de la
        macronie et les arnaques des multinationales, des reportages de terrain
        au plus près de ceux qui luttent, des entretiens, débats et émissions
        comme on en voit plus à la télé, nous avons besoin de vous !
      </p>
      <nav>
        <Link to="/soutien">Je soutiens le Média</Link>
      </nav>
    </Container>
  );
}

export default JoinUsAside;
